
import React from "react";
import { Control } from "react-hook-form";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";
import { WaitlistFormValues } from "../schema";

interface SectionProps {
  control: Control<WaitlistFormValues>;
}

export function PrivacyConsentSection({
  control
}: SectionProps) {
  return (
    <div className="space-y-4">
      <FormField 
        control={control} 
        name="consentToPrivacyPolicy" 
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 p-4 bg-grandpal-beige/20 rounded-lg">
            <FormControl>
              <Checkbox 
                checked={field.value} 
                onCheckedChange={checked => {
                  field.onChange(checked === true);
                }} 
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel required>
                I agree to the <Link to="/privacy-policy" className="text-grandpal-green underline hover:text-grandpal-green-dark/70">privacy policy</Link> and consent to my information being shared with relevant nursing homes
              </FormLabel>
              <FormDescription>
                We'll handle your information with care and only use it for the purposes you've agreed to
              </FormDescription>
              <FormMessage />
            </div>
          </FormItem>
        )} 
      />
    </div>
  );
}
